// -- Imports -- //
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrand_scss = require('./onbrand.scss'); //Onbrand styles
const client_scss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');
const { mobileToggleMenu } = require('./script-partials/header.js');
// -- Startup -- //
production ? null : onbrandUtilityFunctions.devMode(devOptions);
$('body').prepend(htmlHeader);
$('body').append(htmlFooter);
window.onbrandLoaded = false;
onbrandUtilityFunctions.helpfulClasses(); // Adds body classes for content type (blogPost, youtube, etc)
onbrandUtilityFunctions.fixShareWidgetImproved();
onbrandUtilityFunctions.noQueryStringSafeguard(); // warns you if your query string is missing.
onbrandUtilityFunctions.recoEnginePositioning('.top-nav'); //makes the reco engine sticky to the target / top of screen
// -- Custom Functions -- //

/**
 * handle toggle of mobile nav menu items
 * @param {e} e is the event passed to the function.
 * @returns {action} the dropdown for mobile nav will open
 */
function handleNavItemClick(e) {
    const mobile = 768;
    if ($(window).width() < mobile) {
        if (!$(this).hasClass('sub-active')) {
            e.preventDefault();
            $('.navbar-nav .menu-item-has-children').removeClass('sub-active');
            $(this).addClass('sub-active');
        }
    }
}

const toggleNavItems = () => {
    $('.navbar-nav .menu-item-has-children').on('click', handleNavItemClick);
};

const changeOrderFlipBook = () => {
    $('.single-embed-wrapper')
        .detach()
        .appendTo('.entry-wrapper');
};

const removeHeightFromHeader = () => {
    // A custom function is required as product has !important on the header height
    var $header = $('header:not(#navigation)');
    $header.attr('style', 'height: 0px !important');
};

const menuReveal = () => {
    $('.navbar-toggle').on('click', () => {
        $('.navbar-collapse').slideToggle();
    });
};

const fixedHeader = () => {
    if ($(window).scrollTop() > $('#injected-header').height()) {
        $('.top-nav').addClass('fixedHeader');
    } else {
        $('.top-nav').removeClass('fixedHeader');
    }
};

// -- Hub Events -- //
const onLoadAndPageChange = function() {
    onbrandUtilityFunctions.blockCtaFix();
    onbrandUtilityFunctions.fadeOutItem();
    changeOrderFlipBook();
};
Hubs.Events
    .on('load', function() {
        if (!window.onbrandLoaded) {
            onLoadAndPageChange();
            // Add your onloads here...
            changeOrderFlipBook();
            removeHeightFromHeader();
            menuReveal();
            toggleNavItems();
            // Uberflip GWL OB-7479 code start
            mobileToggleMenu();
            // Uberflip GWL OB-7479 code end
            // end your onloads before here...
            window.onbrandLoaded = true;
        }
    })
    .on('pageChange', function() {
        onLoadAndPageChange();
    })
    .on('itemsLoaded', function(itemIds, selectors) {}) /*eslint-disable-line*/
    .on('resize', function() {
        sideCtaFix(); /*eslint-disable-line*/
        addThisFix(); /*eslint-disable-line*/
    })
    .on('scroll', function() {
        sideCtaFix(); /*eslint-disable-line*/
        addThisFix(); /*eslint-disable-line*/
        fixedHeader();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
    })
    .on('ctaActivate', function(ctaId) {})
    .on('ctaFormSubmitSuccess', function(
        ctaId /*eslint-disable-line*/ ,
        mappedData /*eslint-disable-line*/ ,
        ctaName /*eslint-disable-line*/
    ) {})
    .on('search', function() {});

//The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
    Hubs.Events.trigger('load');
}


// WEBPACK FOOTER //
// ./onbrand.js